// AUTO-GENERATED by scripts/build-static-image-variants.mjs — do not edit.
// Run `node scripts/build-static-image-variants.mjs` after changing SOURCES there.

export interface ImageVariant {
  /** Variant widths written to /public, widest first. */
  readonly widths: readonly number[];
  /** Intrinsic size of the source PNG, for reserving the box. */
  readonly width: number;
  readonly height: number;
}

export const IMAGE_VARIANTS: Readonly<Record<string, ImageVariant>> = {
  "/mockups/hero-phones-light.png": { widths: [1440, 720], width: 1440, height: 1080 },
  "/mockups/hero-phones.png": { widths: [1440, 720], width: 1440, height: 1080 },
  "/mockups/hero-phones-en-light.png": { widths: [1079, 720], width: 1079, height: 966 },
  "/mockups/hero-phones-en.png": { widths: [1079, 720], width: 1079, height: 966 },
  "/mockups/hero-phones-mint24-en-light.png": { widths: [1079, 720], width: 1079, height: 966 },
  "/mockups/hero-phones-mint24-en.png": { widths: [1079, 720], width: 1079, height: 966 },
  "/mockups/carousel-editor-light.png": { widths: [1320, 660], width: 1320, height: 2346 },
  "/mockups/carousel-editor.png": { widths: [1320, 660], width: 1320, height: 2346 },
  "/mockups/carousel-editor-en-light.png": { widths: [1320, 660], width: 1320, height: 2346 },
  "/mockups/carousel-editor-en.png": { widths: [1320, 660], width: 1320, height: 2346 },
  "/mockups/carousel-editor-mint24-en-light.png": { widths: [1320, 660], width: 1320, height: 2346 },
  "/mockups/carousel-editor-mint24-en.png": { widths: [1320, 660], width: 1320, height: 2346 },
  "/logo-mint24-icon.png": { widths: [340], width: 675, height: 301 },
  "/logo-mint24-en.png": { widths: [340], width: 748, height: 333 },
  "/logo-mintai.png": { widths: [340], width: 889, height: 291 },
};
